import {Injectable} from '@angular/core';
import {LocalStorageService} from 'app/core/services/local-storage.service';
import {NavigateAfterLoginService} from 'app/features/sign-in/services/navigate-after-login.service';

export const GOOGLE_OAUTH_URL = '/oauth/google';
@Injectable({
    providedIn: 'root',
})
export class SignInWithGoogleService {
    constructor(
        private localStorage: LocalStorageService,
        private afterLogin: NavigateAfterLoginService
    ) {}

    getOAuthUrl() {
        const backToPath = this.afterLogin.getBackPath();
        return backToPath ? `${GOOGLE_OAUTH_URL}?back_to=${encodeURIComponent(backToPath)}` : GOOGLE_OAUTH_URL;
    }

    isEnabled = true;
}
